import { useIntl } from '@edx/frontend-platform/i18n';

const PastExpirationCardContent = () => {
  const { formatMessage } = useIntl();
  return (
    <div className="upgrade-notification-text">
      <p>
        {formatMessage({
          id: 'advertisements.upgradeNotification.pastExpiration.content',
          defaultMessage: 'The upgrade deadline for this course passed. To upgrade, enroll in the next available session.',
          description: 'Content text notifying the user that the deadline passed and how to access course content.',
        })}
      </p>
    </div>
  );
};

export default PastExpirationCardContent;
